import { render, staticRenderFns } from "./CountingApproveDetail.vue?vue&type=template&id=189d5b56"
import script from "./CountingApproveDetail.vue?vue&type=script&lang=js"
export * from "./CountingApproveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports